export default [
  {
    path: '/settings/products/:id/product-templates',
    meta: { requiresAuth: true },
    component: () => import('pages/settings/product-templates/_layouts/ProductTemplatesLayout.vue'),
    children: [
      {
        name: 'ProductTemplatesEdit',
        path: ':productTemplateId/edit',
        component: () => import('pages/settings/product-templates/ProductTemplatesForm.vue')
      },
      {
        name: 'ProductTemplatesHistoryList',
        path: ':productTemplateId/history',
        component: () => import('pages/settings/product-templates/ProductTemplatesHistoryList.vue')
      }
    ]
  },
  {
    name: 'ProductTemplatesList',
    path: '/settings/products/:id/product-templates',
    component: () => import('pages/settings/product-templates/ProductTemplatesList.vue')
  },
  {
    name: 'ProductTemplatesCreate',
    path: '/settings/products/:id/product-templates/new',
    component: () => import('pages/settings/product-templates/ProductTemplatesForm.vue')
  }
]
